<template>
<div class="subject_main" onselectstart="return false;">
    <div class="wrapper">
        <div class="chapter_tree_box">
            <!-- <ul style="overflow: auto;">
              <li :class="book_active==index?'book_item_active':''" class="book_item" v-for="(item,index) in book_list" :key="index" @click="choose_book(item,index)">
                  {{item.name}}-{{item.publish}}
              </li>
            </ul> -->
            <el-tree :data="SectionData" :props="SectionProps" @node-click="getSectionData" node-key='guid'
              :default-expanded-keys="showNode" highlight-current ref="treeBox">
               <div class="tree_line" slot-scope="{ node, data }">
                 <div>{{ node.label }}</div>
                 
               </div>
            </el-tree>
      </div>
      <div class="content">
        <div class="content_head">
          <ul class='course_type_box'>
            <li :key="index" v-for="(item,index) in tab_list_gold" @click="switchTab(index,item)">
              <div :style="{'color':index===tab_active_gold?'#69B4FF':'#333333'}">{{item.name}}</div>
              <div :style="{'opacity':index===tab_active_gold?1:0}" class="course_type_line"></div>
            </li>
          </ul>
        </div>
        <div class="course_box">
          <div class='course_box_head'>
            <div class="course_search">
              <el-input placeholder="请输入名称" v-model="input3" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="btnsearch" style='border-radius:50%'></el-button>
              </el-input>
            </div>
            <div></div>
            
          </div>
          <div class="course_list">
            <div class="course_card" v-for="(item_m_job,index_m_job) in tableData" :key="'m_uuid'+index_m_job">
              <div class="course_card_title">
                <div class='course_card_title_icon'>
                    <img  v-if="['ppt', 'pptx'].indexOf(item_m_job.suffixType.toLowerCase()) > -1" src="../../assets/images/resource/ppt.png" alt="" />
                    <img  v-if="['doc', 'docx'].indexOf(item_m_job.suffixType.toLowerCase()) > -1" src="../../assets/images/resource/word.png" alt="" />
                    <img  v-if="item_m_job.suffixType=='pdf'" src="../../assets/images/resource/pdf.png" alt="" />
                    <img  v-if="item_m_job.suffixType=='png'" src="../../assets/images/resource/图片.png" alt="" />
                    <img  v-if="item_m_job.suffixType=='mp3'" src="../../assets/images/resource/音频.png" alt="" />
                    <img  v-if="item_m_job.suffixType=='mp4'" src="../../assets/images/resource/视频.png" alt="" />
                </div>
                <div class='course_card_title_name'  :title="item_m_job.name">{{item_m_job.name}}</div>
                <!-- <div class='course_card_title_course_heat'><img src="../../assets/images/course_2.0/热度.png" alt="">{{item_m_job.heat}}</div> -->
              </div>
              <div class='course_card_content_item'>
                学科：<span style="color:#69B4FF">{{item_m_job.subject.name}}</span> 
              </div>
              <div class='course_card_content_item'>
                年级：<span style="color:#69B4FF">{{item_m_job.grade.name}}</span>
              </div>
              <div class='course_card_content_item'>
                时间：{{item_m_job.updateTime}}
              </div>
              <!-- <div class='course_card_content_item'>
                时间：{{item_m_job.createtime}}
              </div> -->
            
              <div class='course_card_operation'>
                <div class='course_card_operation_item' @click="download_material(item_m_job)"  title="下载"><img src="../../assets/images/course_2.0/下载.png" alt=""></div>
              </div>
            </div>
            <div v-if="!tableData.length" class='course_card_empty' >
            
            </div>
          </div>
          <div class="course_page" >
              <el-pagination background layout="prev, pager, next" :page-size='pageSize' :total='course_total'
                @current-change='changePage' :current-page='pageNum'>
              </el-pagination>
          </div>
          
        </div>
      </div>
    </div>
</div>
</template>
<script>


  export default {
    data() {
      return {
        text_book_guid:'',
        book_active:0,
        book_list:[],
        SectionData: [],
        showNode:[],
        SectionProps: {
          children: "children",
          label: "name",
        },
        tab_list_gold:[
            { name: "全部", id: 0 },
            { name: "课件", id: 1 },
            { name: "教案", id: 2 },
            { name: "习题/作业", id: 3 },
            { name: "学案/导学案", id: 4 },
            { name: "素材", id: 5 },
            { name: "视频", id: 6 },
            { name: "备课综合", id: 7 },
            
        ],
        tab_active_gold:0,
        input3:'',
        tableData:[],
        course_total:0,
        pageNum:1,
        pageSize:20,
      };
    },
    watch:{
     
    },
    methods: {
      choose_book(item,index){
        // console.log(item)
        this.book_active=index
        this.text_book_guid=item.guid
        this.get_list()
      },
        download_material(item){
            let formdata=new FormData()
            formdata.append('documentId',item.id)
            formdata.append('origin',item.origin)
            this.axios.post("https://schoolswoole.gaokaowin.com/problem_original/document/download", formdata).then(res => {
                 if(res.data.code==200){
                     const link = document.createElement('a');
                    link.href =res.data.data
                    link.download = item.name
                    link.click();
                 }else{
                     this.$message({
                         message:res.data.message,
                         type:'error',
                         durtion:1500,
                     })
                 }
            })
        },
        getSectionData(data) {
            this.chapter_code=data.c
            this.get_list()
        },
        btnsearch() {
            this.pageNum=1
            this.get_list()
        },
        changePage(pageNum) {
            this.pageNum = pageNum;
            this.get_list()
        },
         switchTab (index, item) {
            this.pageNum = 1;
            this.tab_active_gold=index
            this.get_list()
        },
        //获取列表
        get_list(){
            let formdata=new FormData()
            formdata.append('searchType','booknode')
            // console.log(this.text_book_guid+'-----')
            formdata.append('textbookId',this.text_book_guid)
            if(this.chapter_code){
                formdata.append('bookNodeId',this.chapter_code)
            }
            if(this.input3){

                formdata.append('name',this.input3 )
            }
            if(this.tab_active_gold==0){

            }else if(this.tab_active_gold==1){
                formdata.append('documentTypeId',1)
            }else if(this.tab_active_gold==2){
                formdata.append('documentTypeId',2)
            }else if(this.tab_active_gold==3){
                formdata.append('documentTypeId',3)
            }else if(this.tab_active_gold==4){
                formdata.append('documentTypeId',4)
            }else if(this.tab_active_gold==5){
                formdata.append('documentTypeId',5)
            }else if(this.tab_active_gold==6){
                formdata.append('documentTypeId',6)
            }else if(this.tab_active_gold==7){
                formdata.append('documentTypeId',7)
            }
            formdata.append('pageNumber',this.pageNum)
            formdata.append('pageSize',this.pageSize)
             this.axios.post("https://schoolswoole.gaokaowin.com/problem_original/document/getlist", formdata).then(res => {
                 
                 if(res.data.code==200){
                     this.tableData=res.data.data.content
                     this.course_total=res.data.data.totalElements
                 }else{
                     this.$message({
                         message:res.data.message,
                         type:'error',
                         durtion:1500,
                     })
                 }
             })
        },
        //获取教材 章节
      getSubject(code) {
        let that=this
        let formData = new FormData();
        formData.append("subject_code", code);
        this.axios.post("/teacher/subject/gettextbook", formData).then(res => {
          if (res.data.data != "") {
            this.book_list=res.data.data
            this.text_book_guid=this.book_list[0].guid||''
            // console.log(this.text_book_guid)
            this.book = res.data.data;
            for (var i = 0; i < this.book.length; i++) {
              if (
                this.book[i].id ==
                JSON.parse(sessionStorage.userInfo).textbook_code
              ) {
                
                this.book_edit = res.data.data;
                this.changeText =
                  res.data.data[i].name + " - " + res.data.data[i].publish;
                this.changeText_edit =
                  res.data.data[i].name + " - " + res.data.data[i].publish;
                this.book_code_add = res.data.data[i].code;
                this.chapter_add_code = JSON.parse(
                  this.book[i].chapter_json
                )[0].c;

                if (res.data.data[i].chapter_json != "") {
                  let SectionData = JSON.parse(res.data.data[i].chapter_json);
                  this.textbook_code = this.book[i].code;
                  
                  this.tree_code = "";

                  // this.SectionData = this.changeData(SectionData, "");
                  this.SectionData = SectionData
                  for(let i in this.SectionData){
                    this.showNode.push(this.SectionData[i].guid)
                  }
                  sessionStorage.SectionData=JSON.stringify(SectionData)
              
                } else {
                  this.SectionData = [];
                  this.SectionData_edit = [];
                }
                break;
              } else {
                this.book_edit = res.data.data;
                this.changeText =
                  res.data.data[0].name + " - " + res.data.data[0].publish;
                this.changeText_edit =
                  res.data.data[0].name + " - " + res.data.data[0].publish;
                this.book_code_add = res.data.data[0].code;
               
                if (res.data.data[0].chapter_json.length>2) {
                   this.chapter_add_code = JSON.parse(
                  this.book[0].chapter_json
                )[0].c;
                  let SectionData = JSON.parse(res.data.data[0].chapter_json);
                  this.textbook_code = this.book[0].code;
                  let chapter_code = "";
                  for (var j in SectionData) {
                    chapter_code +=
                      j == 0 ? SectionData[j].c : "," + SectionData[j].c;
                  }
                  this.tree_code = "";
                  this.SectionData = SectionData
                } else {
                  this.SectionData = [];
                  this.SectionData_edit = [];
                }
              }
              
              
            }
             


          } else {
            this.book = [];
          }
            this.get_list()
        });
       
      },
     
    },

    mounted() {
        this.getSubject(sessionStorage.subject_code);
       
    },
    beforeDestroy() {
    
    }
  };
</script>
<style >

  .course_search .el-input-group__append{
    border-radius: 0 20px 20px 0;
  }
  .course_search .el-input__inner{
    border-radius: 20px 0 0 20px;
    background: #F8F8F8;
    height: 40px !important;
    font-size: 14px !important;
  }
  .course_search .el-input{
    height: 40px;
  }

</style>

<style scoped>
 .subject_main{
    overflow: hidden;
  }
    .wrapper{
        margin:20px 360px;
        display: flex;
        justify-content: space-between;
        /* background: white; */
        height: calc(100vh - 152px);
        overflow: hidden;
    }
     .chapter_tree_box{
    width: 360px;
    height:100%;
    overflow: auto;
    padding: 10px;
    background: #ffffff;
    border-radius: 12px;
    box-sizing: border-box;
  }
  .tree_line{
    display: flex;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
  }
  .tree_line>div:nth-of-type(1){
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content{
    width:810px;
    /* background: #ffffff; */
    border-radius: 12px;
   
  }
  .course_box{
     border-radius: 12px;
     margin-top:14px ;
  }
  .content_head{
    height: 60px;
    font-size: 16px;
    background: white;
    overflow: hidden;
    border-radius: 12px;
    color: #333333;
   
  }
  .course_type_box{
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    height: 30px;
    margin: 15px 0;
  }
  .course_type_box li{
    cursor: pointer;
  }
  .course_type_line{
    width: 36px;
    height: 5px;
    background: #54A9FD;
    border-radius: 3px;
    margin: 3px auto;
  }
  .course_box_head{
    
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: space-between;
    margin: 14px 16px 17px 18px;
    height: 40px;
  }
  .creat_course{
    /* width: 78px; */
    height: 36px;
    background: #FF9B36;
    border-radius: 10px;
    line-height: 36px;
    text-align: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
     margin-left: 16px;
    padding: 0 10px;
  }
  .course_search{
    height: 40px;
   
  }
  .course_box{
    height:calc( 100vh - 246px);
    background: #ffffff;
    overflow: hidden;
  }
  .course_creat_sort{
    display: flex;
    justify-items: center;
  }
  .course_list{
    height: calc(100% - 124px);
    margin: 0 16px 0 18px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

  }
  .course_card{
    height: 200px;
    width: 240px;
    border: 4px solid #69B4FF;
    box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
    border-radius: 6px 20px 20px 6px;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .course_card:nth-of-type(3n-1){
    margin:0 20px;
 
  }
  .course_card_title{
    height: 30px ;
    line-height: 20px;
    display: flex;
    align-items: center;
    /* margin-bottom: 20px; */
  }
  .course_card_title_icon img{
    display: block;
  }
  .course_card_title_name{
    /* width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
    font-size: 16px; */
    width: 200px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  margin-left: 10px;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  }
  .course_card_title_course_heat{
    display: flex;
    color: #FF3B47;
    margin-left: auto;
  }
  .course_card_title_course_heat img{
    display: block;
    height: 16px;
    margin:3.5px 0;
    margin-right: 3px;
  }
  .course_card_content_item{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .course_card_operation{
    display: flex;
    justify-content: space-between;
  }
  .course_card_operation_item{
    cursor: pointer;
  }
  .course_card_operation_item img{
    display: block;
      width: 26px;
    height: 26px;
  }
  .course_page{
    margin-top:5px;
    text-align: right;
  }
  .course_creat_sort_btn{
    height: 36px;
    background: #F8F8F8;
    border-radius: 10px;
    padding: 0 15px;
    line-height: 36px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .course_card_empty{
    background:url(../../assets/images/course_2.0/老师.png);
    width:100%;
    height:100%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 200px auto;
  }
  .labe_wd{
    height: 180px;
    background: #F8F8F8;
    border-radius: 10px;
    padding:14px;
    /* box-sizing: border-box; */
    margin-bottom: 20px;
    position: relative;
    border: 1px solid #dfdfdf;
  }
  .choose_course_time{
    height: 36px;
    background: #FF9B36;
    border-radius: 10px;
    padding:0 14px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    color: #ffffff;
    
  }
  .marin_bottom{
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    line-height: 32px;
  }
  .choosed_time{
    height: 32px;
    border: 1px solid #FF9B36;
    box-shadow: 0px 0px 4px 0px #FE8B17;
    border-radius: 8px;
    line-height: 32px;
    text-align: center;
    /* margin-top: 10px; */
    padding-right:10px;
    color: #FF9B36;
  }
  .marin_bottom>div:nth-of-type(2){
    height: 32px;
    background: #69B4FF;
    border-radius: 8px;
    padding: 0 18px;
    line-height: 32px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    
  }
  .confirm_cancel{
    display: flex;
    justify-content: space-between;
  }
  .book_item{
    cursor: pointer;
    
  }
  .book_item_active{
    background: #69b4ffbd;
  }
</style>

